<template>
  <div>
    <el-form
      :model="dataForm2"
      :inline="true"
      ref="dataForm2"
      class="demo-form-inline"
      label-width="120px"
    >
      <el-form-item label="" prop="searchInput">
        <el-input
          v-model="dataForm2.searchInput"
          placeholder="名称/品牌/编码/型号"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="" prop="goodsCode">
        <el-input
          v-model="dataForm2.goodsCode"
          placeholder="平台编码"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="" prop="searchInput">
        <el-button size="small" type="primary" @click="doSearch()"
          >查询</el-button
        >
        <el-button size="small" @click="reset()">重置</el-button>
      </el-form-item>
    </el-form>
    <div style="display: flex; height: 400px">
      <Table
        style="width: 100%"
        ref="table"
        :tableConfig="tableConfig"
        :tableEvent="tableEvent"
      ></Table>
    </div>
    <div class="addFunc">
      <el-button size="small" @click="cancelGoods">取消</el-button>
      <el-button size="small" type="primary" @click="confirm">确定</el-button>
    </div>
  </div>
</template>

<script>
import Table from '@/components/table/index'
export default {
  components: { Table },
  props: {
    companyId: {
      type: String,
      default: ''
    },
    dataList: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    this.doSearch()
  },
  data () {
    return {
      multipleSelection: [],
      tableEvent: {
        'selection-change': (v) => {
          this.multipleSelection = v
        }
      },
      tableConfig: {
        searchUrl: '/front/order/lclb/custsp/stockByOrdinary',
        searchMethod: 'POST', // 接口请求方式
        autoSearch: false, // 是否需要默认查询
        needPagination: true, // 是否需要分页
        fluidHeight: true, // 流体高度
        showOrdinal: true, // 是否显示序号,
        resultListName: 'data',
        showCheckBox: true,
        height: '400px',
        checkBoxRowKey: 'oldGoodsCode',
        checkSelectable: (row) => {
          const res = this.dataList.some((item) => {
            if (item.oldGoodsCode === row.oldGoodsCode) {
              return true
            }
            return false
          })
          return !res
        },
        params: [
          {
            prop: 'oldGoodsCode',
            label: '物品编码'
          },
          {
            prop: 'goodsCode',
            label: '平台商品编码'
          },
          {
            prop: 'oldGoodsName',
            label: '物品名称',
            showOverflowTooltip: true
          },
          {
            prop: 'oldSpecification',
            label: '规格',
            showOverflowTooltip: true
          },
          {
            prop: 'oldModel',
            label: '型号',
            showOverflowTooltip: true
          },
          {
            prop: 'brand',
            label: '品牌',
            showOverflowTooltip: true
          },
          {
            prop: 'sellingUnit',
            label: '单位',
            width: '60px',
            showOverflowTooltip: true
          },
          {
            prop: 'oldRemark',
            label: '备注',
            width: '150px',
            showOverflowTooltip: true
          }
        ],
        extra: {} // 额外的参数 搜索的条件
      },
      dataForm2: {
        searchInput: '',
        goodsCode: ''
      }
    }
  },
  methods: {
    selectedRow (row, ...other) {
      console.log(row, other)
      const isSelected = this.multipleSelection.includes(row)
      this.$refs.table.$refs.tableList.toggleRowSelection(row, !isSelected)
    },
    getRowKeys (row) {
      return row.goodsCode
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    confirm () {
      this.$emit('selected', this.multipleSelection)
    },
    cancelGoods () {
      this.$emit('close')
    },
    reset () {
      this.dataForm2 = {
        searchInput: '',
        goodsCode: ''
      }
      this.doSearch()
    },
    doSearch () {
      this.tableConfig.extra = {
        companyId: this.companyId,
        searchInput: this.dataForm2.searchInput,
        goodsCode: this.dataForm2.goodsCode,
        skuAvailableStatus: 2,
        tab: '02',
        includeInvalidSku: true
      }
      this.$refs.table.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.addFunc {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.addCancel {
  width: 158px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: #1d65a8;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
}
</style>
